{
  "AF": "Afghanistan",
  "ZA": "Sudafrica",
  "AL": "Albania",
  "DZ": "Algeria",
  "DE": "Germania",
  "AD": "Andorra",
  "AO": "Angola",
  "AI": "Anguilla",
  "AQ": "Antartide",
  "AG": "Antigua e Barbuda",
  "SA": "Arabia Saudita",
  "AR": "Argentina",
  "AM": "Armenia",
  "AW": "Aruba",
  "AU": "Australia",
  "AT": "Austria",
  "AZ": "Azerbaigian",
  "BS": "Bahamas",
  "BH": "Bahrein",
  "BD": "Bangladesh",
  "BB": "Barbados",
  "BE": "Belgio",
  "BZ": "Belize",
  "BJ": "Benin",
  "BM": "Bermuda",
  "BT": "Bhutan",
  "BY": "Bielorussia",
  "BO": "Bolivia",
  "BA": "Bosnia ed Erzegovina",
  "BW": "Botswana",
  "BR": "Brasile",
  "BN": "Brunei",
  "BG": "Bulgaria",
  "BF": "Burkina Faso",
  "BI": "Burundi",
  "KH": "Cambogia",
  "CM": "Camerun",
  "CA": "Canada",
  "CV": "Capo Verde",
  "EA": "Ceuta e Melilla",
  "CL": "Cile",
  "CN": "Cina",
  "CY": "Cipro",
  "CO": "Colombia",
  "KM": "Comore",
  "CG": "Congo-Brazzaville",
  "CD": "Congo-Kinshasa",
  "KP": "Corea del Nord",
  "KR": "Corea del Sud",
  "CR": "Costa Rica",
  "CI": "Costa d'Avorio",
  "HR": "Croazia",
  "CU": "Cuba",
  "CW": "Curaçao",
  "DK": "Danimarca",
  "DG": "Diego Garcia",
  "DJ": "Gibuti",
  "DM": "Dominica",
  "EG": "Egitto",
  "SV": "El Salvador",
  "AE": "Emirati Arabi Uniti",
  "EC": "Ecuador",
  "ER": "Eritrea",
  "ES": "Spagna",
  "EE": "Estonia",
  "VA": "Città del Vaticano",
  "FM": "Micronesia",
  "US": "Stati Uniti",
  "ET": "Etiopia",
  "EZ": "Eurozona",
  "FJ": "Figi",
  "FI": "Finlandia",
  "FR": "Francia",
  "GA": "Gabon",
  "GM": "Gambia",
  "GE": "Georgia",
  "GS": "Georgia del Sud e Isole Sandwich Australi",
  "GH": "Ghana",
  "GI": "Gibilterra",
  "GR": "Grecia",
  "GD": "Grenada",
  "GL": "Groenlandia",
  "GP": "Guadalupa",
  "GU": "Guam",
  "GT": "Guatemala",
  "GG": "Guernsey",
  "GN": "Guinea",
  "GQ": "Guinea Equatoriale",
  "GW": "Guinea-Bissau",
  "GY": "Guyana",
  "GF": "Guyana Francese",
  "HT": "Haiti",
  "HN": "Honduras",
  "HU": "Ungheria",
  "CX": "Isola di Natale",
  "AC": "Isola dell'Ascensione",
  "IM": "Isola di Man",
  "NF": "Isola Norfolk",
  "AX": "Isole Åland",
  "KY": "Isole Cayman",
  "IC": "Isole Canarie",
  "CC": "Isole Cocos",
  "CK": "Isole Cook",
  "FO": "Isole Fær Øer",
  "FK": "Isole Falkland",
  "MP": "Isole Marianne Settentrionali",
  "MH": "Isole Marshall",
  "UM": "Isole Minori Esterne degli Stati Uniti",
  "PN": "Isole Pitcairn",
  "SB": "Isole Salomone",
  "TC": "Isole Turks e Caicos",
  "VG": "Isole Vergini Britanniche",
  "VI": "Isole Vergini Americane",
  "IN": "India",
  "ID": "Indonesia",
  "IQ": "Iraq",
  "IR": "Iran",
  "IE": "Irlanda",
  "IS": "Islanda",
  "IL": "Israele",
  "IT": "Italia",
  "JM": "Giamaica",
  "JP": "Giappone",
  "JE": "Jersey",
  "JO": "Giordania",
  "KZ": "Kazakistan",
  "KE": "Kenya",
  "KG": "Kirghizistan",
  "KI": "Kiribati",
  "XK": "Kosovo",
  "KW": "Kuwait",
  "RE": "Riunione",
  "LA": "Laos",
  "LS": "Lesotho",
  "LV": "Lettonia",
  "LB": "Libano",
  "LR": "Liberia",
  "LY": "Libia",
  "LI": "Liechtenstein",
  "LT": "Lituania",
  "LU": "Lussemburgo",
  "MK": "Macedonia del Nord",
  "MG": "Madagascar",
  "MY": "Malaysia",
  "MW": "Malawi",
  "MV": "Maldive",
  "ML": "Mali",
  "MT": "Malta",
  "MA": "Marocco",
  "MQ": "Martinica",
  "MU": "Mauritius",
  "MR": "Mauritania",
  "YT": "Mayotte",
  "MX": "Messico",
  "MD": "Moldavia",
  "MC": "Monaco",
  "MN": "Mongolia",
  "ME": "Montenegro",
  "MS": "Montserrat",
  "MZ": "Mozambico",
  "MM": "Myanmar (Birmania)",
  "NA": "Namibia",
  "UN": "Nazioni Unite",
  "NR": "Nauru",
  "NP": "Nepal",
  "NI": "Nicaragua",
  "NE": "Niger",
  "NG": "Nigeria",
  "NU": "Niue",
  "NO": "Norvegia",
  "NC": "Nuova Caledonia",
  "NZ": "Nuova Zelanda",
  "OM": "Oman",
  "UG": "Uganda",
  "UZ": "Uzbekistan",
  "PK": "Pakistan",
  "PW": "Palau",
  "PA": "Panama",
  "PG": "Papua Nuova Guinea",
  "PY": "Paraguay",
  "NL": "Paesi Bassi",
  "BQ": "Paesi Bassi Caraibici",
  "PE": "Perù",
  "PH": "Filippine",
  "PL": "Polonia",
  "PF": "Polinesia Francese",
  "PR": "Porto Rico",
  "PT": "Portogallo",
  "QA": "Qatar",
  "HK": "RAS di Hong Kong",
  "MO": "RAS di Macao",
  "CF": "Repubblica Centrafricana",
  "DO": "Repubblica Dominicana",
  "RO": "Romania",
  "GB": "Regno Unito",
  "RU": "Russia",
  "RW": "Ruanda",
  "EH": "Sahara Occidentale",
  "BL": "Saint-Barthélemy",
  "KN": "Saint Kitts e Nevis",
  "SM": "San Marino",
  "MF": "Saint-Martin",
  "SX": "Saint-Martin (parte olandese)",
  "PM": "Saint-Pierre e Miquelon",
  "VC": "Saint Vincent e Grenadine",
  "SH": "Sant'Elena",
  "LC": "Santa Lucia",
  "WS": "Samoa",
  "AS": "Samoa Americane",
  "ST": "São Tomé e Príncipe",
  "SN": "Senegal",
  "RS": "Serbia",
  "SC": "Seychelles",
  "SL": "Sierra Leone",
  "SG": "Singapore",
  "SK": "Slovacchia",
  "SI": "Slovenia",
  "SO": "Somalia",
  "SD": "Sudan",
  "SS": "Sudan del Sud",
  "LK": "Sri Lanka",
  "SE": "Svezia",
  "CH": "Svizzera",
  "SR": "Suriname",
  "SJ": "Svalbard e Jan Mayen",
  "SZ": "Swaziland",
  "SY": "Siria",
  "TJ": "Tagikistan",
  "TW": "Taiwan",
  "TZ": "Tanzania",
  "TD": "Ciad",
  "CZ": "Cechia",
  "TF": "Terre Australi e Antartiche Francesi",
  "IO": "Territorio Britannico dell'Oceano Indiano",
  "PS": "Territori Palestinesi",
  "TH": "Thailandia",
  "TL": "Timor Est",
  "TG": "Togo",
  "TK": "Tokelau",
  "TO": "Tonga",
  "TT": "Trinidad e Tobago",
  "TA": "Tristan da Cunha",
  "TN": "Tunisia",
  "TM": "Turkmenistan",
  "TR": "Turchia",
  "TV": "Tuvalu",
  "UA": "Ucraina",
  "UY": "Uruguay",
  "VU": "Vanuatu",
  "VE": "Venezuela",
  "VN": "Vietnam",
  "WF": "Wallis e Futuna",
  "YE": "Yemen",
  "ZM": "Zambia",
  "ZW": "Zimbabwe"
}
